import type { ReactNode } from 'react';
import styles from './FieldShell.module.css';

export interface FieldShellProps {
  htmlFor: string;
  label?: string;
  hint?: string;
  error?: string;
  optional?: boolean;
  hintId: string;
  errorId: string;
  children: ReactNode;
}

/** Shared label/hint/error layout for Input, Textarea and Select. Not exported from the design system index — it's plumbing, not a component in its own right. */
export function FieldShell({ htmlFor, label, hint, error, optional, hintId, errorId, children }: FieldShellProps) {
  return (
    <div className={styles.shell}>
      {label && (
        <div className={styles.labelRow}>
          <label htmlFor={htmlFor} className={styles.label}>
            {label}
          </label>
          {optional && <span className={styles.optional}>Optional</span>}
        </div>
      )}
      {children}
      {error ? (
        <span id={errorId} className={styles.error} role="alert">
          {error}
        </span>
      ) : (
        hint && (
          <span id={hintId} className={styles.hint}>
            {hint}
          </span>
        )
      )}
    </div>
  );
}
